export type UserRole = 'ADMIN' | 'OPERATIONS' | 'PARTNER' | 'ORDER_STAFF' | 'TESTER';

export interface AuthPermissionUser {
  role: UserRole;
  canManageOrderCosts?: boolean;
  canManagePurchaseInvoices?: boolean;
  canManageSupplierOrders?: boolean;
  canViewCustomerOrderFallbackCosts?: boolean;
  canEditCustomerOrderFallbackCosts?: boolean;
  canViewCustomerSalePrices?: boolean;
  canEditCustomerSalePrices?: boolean;
  canViewSupplierPurchasePrices?: boolean;
  canEditSupplierPurchasePrices?: boolean;
  canEditWarehouseDocumentPurchasePrices?: boolean;
  canEditPZDocumentPurchasePrices?: boolean;
  canViewSupplierOrderPurchasePrices?: boolean;
  canEditSupplierOrderPurchasePrices?: boolean;
  canViewSupplierOrderFinance?: boolean;
  canEditSupplierOrderFinance?: boolean;
  canViewSalesDocuments?: boolean;
  canViewPurchaseDocuments?: boolean;
  canViewFinancialReports?: boolean;
  canViewDashboardFullKpis?: boolean;
  canViewCustomerPayments?: boolean;
  canViewTransportCosts?: boolean;
  canEditTransportCosts?: boolean;
  canViewMargin?: boolean;
}

export type BooleanCapabilityKey = Exclude<keyof AuthPermissionUser, 'role'>;
export type RoleInput = string | string[];

export const isAdminUser = (user: AuthPermissionUser | null | undefined) => user?.role === 'ADMIN';

const readCapability = (
  user: AuthPermissionUser | null | undefined,
  key: BooleanCapabilityKey
): boolean | undefined => {
  const value = user?.[key];
  return typeof value === 'boolean' ? value : undefined;
};

export const resolveUserCapability = (
  user: AuthPermissionUser | null | undefined,
  key: BooleanCapabilityKey,
  fallback: boolean
): boolean => readCapability(user, key) ?? fallback;

export const hasUserRole = (user: AuthPermissionUser | null | undefined, role: RoleInput): boolean => {
  if (!user) return false;
  const roles = Array.isArray(role) ? role : [role];
  return roles.includes(user.role);
};
